import {
  CapaQuotationChatRoomStatus,
  CapaRfqQuotationType
} from '@generated/graphql';
import { ActionType } from 'typesafe-actions';
import * as actions from './actions';

export type SideMenuState =
  | 'Viewer'
  | 'DrawingFileManagement'
  | 'Request'
  | 'Quotation'
  | 'PurchaseOrder'
  | 'CreatePurchaseOrder'
  | 'ReCreatePurchaseOrder'
  | 'Helper';

export enum SideMenuStateEnum {
  Viewer = 'Viewer',
  DrawingFileManagement = 'DrawingFileManagement',
  Request = 'Request',
  Quotation = 'Quotation',
  PurchaseOrder = 'PurchaseOrder',
  CreatePurchaseOrder = 'CreatePurchaseOrder',
  ReCreatePurchaseOrder = 'ReCreatePurchaseOrder',
  Helper = 'Helper'
}

export interface IDashboardState {
  chatRoomId?: string;
  previousPath?: string;
  selectedRfqId?: string;
  selectedChatRoomId?: string;
  selectedQuotationId?: QuotationIdType;
  selectedSideMenu?: SideMenuState;
  disabledSideMenu?: SideMenuState[];
}

export type QuotationType =
  | CapaRfqQuotationType.Detail
  | CapaRfqQuotationType.Simple
  | 'NO_QUOTATION'
  | 'REQUEST';

export type DashboardAction = ActionType<typeof actions>;

export type QuotationIdType = {
  chatRoomId?: string;
  rfqId?: string;
  partnerId?: string;
  quotationId?: string;
  organizationName?: string;
  quotationType?: QuotationType;
  isWithdrawn?: boolean;
  ordered?: boolean;
  isPurchaseOrder?: boolean;
  isOnlyIntroduction?: boolean;
  chatRoomStatus?: CapaQuotationChatRoomStatus;
};
